import React, { FC, ReactNode, useContext, useState } from 'react';
// import classNames from 'classnames';
// import { useTour } from '@reactour/tour';
import Button, { IButtonProps } from 'components/bootstrap/Button';
import { HeaderRight } from 'layout/Header/Header';
import OffCanvas, {
	OffCanvasBody,
	OffCanvasHeader,
	OffCanvasTitle,
} from 'components/bootstrap/OffCanvas';
import Alert from 'components/bootstrap/Alert';
import Icon from 'components/icon/Icon';
import ThemeContext from 'contexts/themeContext';
import useDarkMode from 'hooks/useDarkMode';
import Popovers from 'components/bootstrap/Popovers';
import { RootState } from 'stores/store';
import { useSelector } from 'react-redux';
import { IdTypeEnumForSearchEnum } from 'enums';

interface ICommonHeaderRightProps {
	beforeChildren?: ReactNode;
	afterChildren?: ReactNode;
}
const CommonHeaderRight: FC<ICommonHeaderRightProps> = ({ beforeChildren, afterChildren }) => {
	const { darkModeStatus, setDarkModeStatus } = useDarkMode();

	const { notifications } = useSelector((state: RootState) => state.auth);

	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const styledBtn: IButtonProps = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const [offcanvasStatus, setOffcanvasStatus] = useState(false);

	// const { setIsOpen } = useTour();

	return (
		<HeaderRight>
			<div className='row g-3'>
				{beforeChildren}
				{/* Tour Modal */}
				{/* <div className='col-auto position-relative'>
					<Popovers trigger='hover' desc='Start the "Meverify" tour'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							icon='Tour'
							onClick={() => setIsOpen(true)}
							aria-label='Start the "Meverify" tour'
						/>
					</Popovers>
					<Icon
						icon='Circle'
						className={classNames(
							'position-absolute start-65',
							'text-danger',
							'animate__animated animate__heartBeat animate__infinite animate__slower',
						)}
					/>
				</div> */}

				{/* Dark Mode */}
				<div className='col-auto'>
					<Popovers trigger='hover' desc='Dark / Light mode'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							onClick={() => setDarkModeStatus(!darkModeStatus)}
							className='btn-only-icon'
							data-tour='dark-mode'
							aria-label='Toggle dark mode'>
							<Icon
								icon={darkModeStatus ? 'DarkMode' : 'LightMode'}
								color={darkModeStatus ? 'info' : 'warning'}
								className='btn-icon'
							/>
						</Button>
					</Popovers>
				</div>

				{/*	Full Screen */}
				<div className='col-auto'>
					<Popovers trigger='hover' desc='Fullscreen'>
						<Button
							// eslint-disable-next-line react/jsx-props-no-spreading
							{...styledBtn}
							icon={fullScreenStatus ? 'FullscreenExit' : 'Fullscreen'}
							onClick={() => setFullScreenStatus(!fullScreenStatus)}
							aria-label='Toggle fullscreen'
						/>
					</Popovers>
				</div>

				{/*	Notifications */}
				<div className='col-auto'>
					<Button
						// eslint-disable-next-line react/jsx-props-no-spreading
						{...styledBtn}
						icon='Notifications'
						onClick={() => setOffcanvasStatus(true)}
						aria-label='Notifications'
					/>
				</div>
				{afterChildren}
			</div>

			<OffCanvas
				id='notificationCanvas'
				titleId='offcanvasExampleLabel'
				placement='end'
				isOpen={offcanvasStatus}
				setOpen={setOffcanvasStatus}>
				<OffCanvasHeader setOpen={setOffcanvasStatus}>
					<OffCanvasTitle id='offcanvasExampleLabel'>Notifications</OffCanvasTitle>
				</OffCanvasHeader>
				<OffCanvasBody>
					{notifications &&
						notifications!.map((item: any, index: number) => {
							const namespaceString = item.notifiable_type;
							const namespaceArray = namespaceString.split('\\');
							const lastItem =
								namespaceArray[namespaceArray.length - 1].toLowerCase();
							let icon = 'AccessAlarm';
							switch (lastItem) {
								case IdTypeEnumForSearchEnum.COMPANY:
									icon = 'Tonality';
									break;
								case IdTypeEnumForSearchEnum.CURRENCY:
									icon = 'Payments';
									break;
								case IdTypeEnumForSearchEnum.CUSTOMER:
									icon = 'AccountCircle';
									break;
								case IdTypeEnumForSearchEnum.CUSTOMER_PLAN:
									icon = 'StackedBarChart';
									break;
								case IdTypeEnumForSearchEnum.PLAN:
									icon = 'AutoAwesomeMotion';
									break;
								case IdTypeEnumForSearchEnum.PRODUCT:
									icon = 'VerticalDistribute';
									break;
								case IdTypeEnumForSearchEnum.PROJECT:
									icon = 'Terrain';
									break;
								case IdTypeEnumForSearchEnum.USER:
									icon = 'Person';
									break;
								case IdTypeEnumForSearchEnum.WALLET:
									icon = 'AccountBalanceWallet';
									break;
								case IdTypeEnumForSearchEnum.ROLE:
									icon = 'AccountBalanceWallet';
									break;
							}

							return (
								<Alert
									key={item.id || index}
									icon={icon}
									isLight
									color={item.read_at ? 'light' : 'info'}
									className='flex-nowrap'>
									{item.data.title}
								</Alert>
							);
						})}
				</OffCanvasBody>
			</OffCanvas>
		</HeaderRight>
	);
};

export default CommonHeaderRight;
